import OrderListView from "@/views/followup-manager/orders/OrderListView";

export default [
  {
    name: "pages.followup-manager.orders",
    path: "orders",
    component: OrderListView
  },
  
];
